import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CloProfileMenu, CloProfileMenuItem, CloProfileUser} from './profile-menu';

export {CloProfileMenu, CloProfileUser, CloProfileMenuItem} from './profile-menu';

@NgModule({
  declarations: [CloProfileMenu, CloProfileMenuItem, CloProfileUser],
  exports: [CloProfileMenuItem, CloProfileUser, CloProfileMenu],
  imports: [CommonModule],
  entryComponents: [CloProfileMenu]
})
export class CloProfileMenuModule {
}
